import React, { Component } from 'react'
import  {Modal, Dropdown} from 'react-bootstrap'
import {newLogin,verifyOTP,insertFreeCredit, cookie, validateOTP, setCookie} from '../Common/Utils'
import styles from '../../Css/CustomSettings.module.css'
import Axios from 'axios'
import GoogleLogin from 'react-google-login'
import { ContextConsumer, AuthContext } from '../../context/GlobalState'

import posthog from 'posthog-js';

// posthog.init("phc_p92egRlXhuEzPYkMaQVakJl0XCI82X507N84clTaJHH", {api_host: 'https://app.posthog.com'});
posthog.init("FoIzpWdbY_I9T_4jr5k4zzNuVJPcpzs_mIpO6y7581M", {api_host: 'https://app.posthog.com'});


class LoginScreen extends Component {

    

    constructor(props){
        super(props)
        this.state={
            loginCheck:true,
            userEmail:'',
            otpSent:false,
            otp:'',
            error:false,
            stepOne:true,
            suv: true,
            sedan:false,
            hatchback: false,
            category:'suv',
            userId:'',
            otpValid: true,
            flagOTP:false,
            islogin: false,
            isPassword: true,
            password: '',
            validEmail:false,
            emailExists: false,
            otpMessage: false,
            distributor_list:[],
            distributor_api:"",
            isDistributor:false,
            userName:'',
            stepOneLogin: false,
            isSigningIn : false
        }
        this.passwordRef = React.createRef()
    }

    static contextType = AuthContext


    componentDidMount = () => {
        let userEmail = cookie("emailId")
        let userId = cookie("userId")
        if(userId && userEmail && this.context.auth.loggedIn){
            this.setState({
                stepOne:true,
                loginCheck:false,
                otpSent:true,
                flagOTP:true,
            })
        }
        Axios({
            'method':"GET",
            'url':process.env.REACT_APP_BASEURL + '/v2/user/distributor'
        })
        .then((res) => {
            this.setState({
                distributor_list:res?.data?.data
            })
            // console.log(res.data)
        })


        
    }
    handledistributor=(select)=>{
        // console.log(select)
        if(select=="null"){
            this.setState({
            distributor_api:"",
            distributor_logo:"",
            distributor_name:"",
            
            })
        }
        else{
            this.setState({
                distributor_api:select['api_key'],
                distributor_logo:select['logo_url'],
                distributor_name:select['name'],
            })
        }
        
    }
    handleCloseModal = () => {
        if(this.state.flagOTP) {
            this.props.hideModal()
        }
    }
    sendOTP = (e) => {
        e.preventDefault()
        const data = new FormData()
        data.append('api_key', process.env.REACT_APP_API_KEY)
        data.append('email_id', this.state.userEmail)
        newLogin(data)
        .then((success) => {
           this.setState({
               otpSent:true,
               userId:success.data?.user_id,
               loginCheck:false,
               otpMessage: true
           })
        })
        .catch((err) => this.setState({error:true}))

    }
    handleChange = (e) => {
        e.preventDefault()
        this.setState({
            userEmail:e.target.value,
            
        })
    }
    handleChangeOTP = (e) => {
        e.preventDefault()
        this.setState({
            otp:e.target.value
        })
    }
    handleChangePassword = (e) => {
        e.preventDefault()
        this.setState({
            password:e.target.value
        })
    }
    verifyOtp = (e) => {
        e.preventDefault()
        const fd = new FormData()
        fd.append('api_key', process.env.REACT_APP_API_KEY)
        fd.append('email_id', this.state.userEmail)
        fd.append('otp', this.state.otp)
        fd.append('user_name', "AA")
        fd.append('country', "India")
        validateOTP(fd)
            .then((verified) => {

                if (verified.data?.status === 200) {
                    this.setState({
                        loginCheck:false,
                        flagOTP:true,
                        otpMessage: false,
                    })
                    document.cookie = `emailId=${this.state.userEmail}; path=/`;
                    document.cookie = `userId=${this.state.userId}; path=/`;
                    document.cookie = `auth_token=${verified.data?.auth_token}; path=/`;
                    this.context.loggedIn({
                        loggedIn: true,
                        user: {
                            emailId: this.state.userEmail,
                            userId: verified.data?.user_id
                        },
                        token: verified.data?.auth_token,
                        apiKey: process.env.REACT_APP_API_KEY
                    })
                } else {
                    this.setState({
                        otpValid:false
                    })
                }
            }
        )
        .catch((err) => this.setState({loginCheck:true}))
    }
    handleFistMessage = (e) => {
        e.preventDefault()
        
        if (cookie('userId') && cookie('emailId') && cookie('auth_token')) {
            window.location.reload()
        } else {
            this.setState({
                loginCheck:true,
                stepOne:true
            })
        }
    }

    changeCategory = (name) => {
        // e.preventDefault();
        this.setState({
            category:name
        })
    }

    handleSignUpPassword = (e) => {
        e.preventDefault();
        this.setState({
            isSigningIn:true
        })
        const fd = new FormData();
        fd.append('email_id', this.state.userEmail)
        fd.append('password', this.state.password)
        fd.append('strategy', 'PASSWORD')
        fd.append('user_name', 'default')
        fd.append('signup_url', window.location.href)
        fd.append('source', 'Web')
        // console.log(this.state.distributor_api)
        if(this.state.distributor_api==""){
            fd.append('api_key', process.env.REACT_APP_API_KEY)
        }
        else{
            // const flag = 'false'
            // {this.state.isDistributor ? flag = 'true' : flag = 'false'}

            fd.append('if_distributor', 'true')
            fd.append('api_key', this.state.distributor_api)
        }

        if(this.props.productHunt == 'producthunt'){
            fd.append('page_source', "productHunt")
        }
        Axios({
            method: "POST",
            url: process.env.REACT_APP_BASEURL + "/v2/user/signup",
            data : fd,
        }).then(resp => {
            if (resp?.data?.status !== 200) {
                this.setState({
                    // loginCheck:true,
                    flagOTP:true,
                    emailExists: true
                })
            } else if (resp?.data?.status === 200) {
                this.setState({
                    userId : resp.data.user_id,
                    // loginCheck:false,
                    flagOTP:true
                })


                posthog.capture('Login', { $set: { email: this.state.userEmail, userId : resp.data.user_id, newUser: 'true'} });
                document.cookie = `emailId=${this.state.userEmail}; path=/`;
                document.cookie = `userId=${this.state.userId}; path=/`;
                document.cookie = `auth_token=${resp.data?.auth_token}; path=/`;
                document.cookie = `ssoToken=${resp.data?.auth_token}; path=/`;
                document.cookie = `enterpriseId=TaD1VC1Ko; path=/`;
                this.context.loggedIn({
                    loggedIn: true,
                    user: {
                        emailId: this.state.userEmail,
                        userId: resp.data?.user_id
                    },
                    token: resp.data?.auth_token,
                    apiKey: process.env.REACT_APP_API_KEY
                })
                // window.location.reload()
                this.props.insertUsersImage(resp.data?.auth_token)
            }
           
        })
    }

    handleLogin = (e) => {
        e.preventDefault()
        console.log(this.context)
        let strategy,password;

        const fd = new FormData()
        fd.append('api_key', process.env.REACT_APP_API_KEY)
        if(this.props.productHunt == 'producthunt'){
            fd.append('page_source', "productHunt")
        }
        if(this.state.isPassword){
            fd.append('strategy', 'PASSWORD')
            fd.append('email_id', this.state.userEmail)
            fd.append('password', this.state.password)
            Axios({
                method: "POST",
                url: process.env.REACT_APP_BASEURL + "/v2/user/login",
                data : fd
            })
            .then(this.handleLoginResponse)
        }else{
            
            fd.append('email_id', this.state.userEmail)
            fd.append('otp', this.state.otp)
            fd.append('signup_url', window.location.href)
            fd.append('source', 'Web')
            Axios({
                url: process.env.REACT_APP_BASEURL + '/v2/user/validate-otp',
                method: 'POST',
                data: fd
            })
            .then(this.handleLoginResponse)
        }
        
    }

    handleOtpRequest = (e) => {
        e.preventDefault()
        const fd = new FormData()
        fd.append('email_id', this.state.userEmail)
        fd.append('api_key', process.env.REACT_APP_API_KEY)
        this.setState({
            otp: ''
        })
        Axios({
            method: "POST",
            url: process.env.REACT_APP_BASEURL + "/v2/user/request-otp",
            data: fd
        }).then(resp => {

            if (resp.data?.status == 200) {
                this.setState({
                    otpSent:true,
                    validEmail: false,
                    loginCheck:true,
                    otpMessage: true
                })
            } else {
                this.setState({
                    validEmail: true
                })
            }
        })
    }

    handleLoginModal = (e) => {
        e.preventDefault()

        // Check if user details exist in cookies
        if (cookie('userId') && cookie('emailId') && cookie('auth_token')) {
            window.location.reload()
        } else {
            this.setState({
                islogin: true,
                loginCheck:true,
                stepOne:true,
                otpMessage: false,
                stepOneLogin: !this.state.stepOneLogin
            })
        }
    }

    handleOTP = (e) => {
        e.preventDefault()
        this.setState({
            isPassword: false,
            otpMessage: false,
            otp: '',
            password: '',
            isDistributor:false,
            distributor_api:"",
            stepOne: false
        })
        if (this.passwordRef.current) 
            this.passwordRef.current.value = ''
    }

    handlePassword = () => {
        this.setState({
            isPassword: true,
            otpMessage: false,
            otp: '',
            password: '',
            isDistributor:false,
            distributor_api:"",
            stepOne: false,
            loginCheck: false
        })
        if (this.passwordRef.current) 
            this.passwordRef.current.value = '' 
    }

    handleOtp = () => {
        this.setState({
            isPassword: false,
            otpMessage: false,
            otp: '',
            password: '',
            isDistributor:false,
            distributor_api:"",
            stepOne: false,
            loginCheck: false
        })
        if (this.passwordRef.current) 
            this.passwordRef.current.value = ''
    }

    handleIsDistributor = (e) => {
        e.preventDefault()
        if(this.state.isPassword===false)
        {
            this.setState({
                isPassword: !this.state.isPassword,
                isDistributor:true
        })
        }
        this.setState({
            isDistributor: !this.state.isDistributor,
        })
    }

    loginModal = (e) => {
        e.preventDefault()
        this.setState({
            islogin: false,
            stepOne: false,
            otpMessage: false
        })
    }

    handleLoginResponse = (resp) => {
        if(resp?.data?.status === 200){

            posthog.capture('Login', { $set: { email: this.state.userEmail, userId : resp.data.user_id, newUser: 'false'} });
            
            this.setState({
                // loginCheck:false,
                flagOTP:true,
                userId: resp.data.user_id,
                validEmail: false
            })
            document.cookie = `emailId=${this.state.userEmail}; path=/`;
            document.cookie = `userId=${this.state.userId}; path=/`;
            document.cookie = `auth_token=${resp.data?.auth_token}; path=/`;
            document.cookie = `ssoToken=${resp.data?.auth_token}; path=/`;
            document.cookie = `enterpriseId=TaD1VC1Ko; path=/`;
           
            this.context.loggedIn({
                loggedIn: true,
                user: {
                    emailId: this.state.userEmail,
                    userId: resp.data.user_id
                },
                token: resp.data.auth_token,
                apiKey: process.env.REACT_APP_API_KEY
            })
            // window.location.reload()
            this.props.insertUsersImage(resp.data?.auth_token)
        }else if(resp?.data?.status != 200){
            this.setState({
                loginCheck:true,
                flagOTP:false,
                validEmail: true
               
            })
            // console.log(this.context)
        }
    }

    responseGoogle = (response) => {
        // console.log(response);
        var userEmail = response.profileObj.email
        var userName = response.profileObj.name
        this.setState({
            userEmail: userEmail,
            userName: userName
        })

        if(this.state.islogin){
            this.handleGoogleLogin(userEmail,userName)
        }else{
            this.handleGoogleSignIn(userEmail,userName)
        }
        
    }

    handleGoogleSignIn = (userEmail,userName) => {
        // e.preventDefault()
        const fd = new FormData()
        fd.append('email_id', userEmail)
        fd.append('api_key', process.env.REACT_APP_API_KEY)
        fd.append('user_name', userName)
        fd.append('signup_url', window.location.href)
        fd.append('signup_source', 'Web')
        fd.append('strategy', 'GOOGLE')
        Axios({
            method: "POST",
            url: process.env.REACT_APP_BASEURL + "/v2/user/signup",
            data : fd,
        }).then(resp => {
            if (resp?.data?.status !== 200) {
                this.setState({
                    userId : resp.data.user_id,
                })
                document.cookie = `emailId=${this.state.userEmail}; path=/`;
                document.cookie = `userId=${this.state.userId}; path=/`;
                document.cookie = `auth_token=${resp.data?.auth_token}; path=/`;
                document.cookie = `ssoToken=${resp.data?.auth_token}; path=/`;
                document.cookie = `enterpriseId=TaD1VC1Ko; path=/`;

                posthog.capture('Login', { $set: { email: this.state.userEmail, userId : resp.data.user_id, newUser: 'true'} });
                
                this.context.loggedIn({
                    loggedIn: true,
                    user: {
                        emailId: this.state.userEmail,
                        userId: resp.data?.user_id
                    },
                    token: resp.data?.auth_token,
                    apiKey: process.env.REACT_APP_API_KEY
                })
                // window.location.reload()
                this.props.insertUsersImage(resp.data?.auth_token)
            } else if (resp?.data?.status === 200) {
                this.setState({
                    userId : resp.data.user_id,
                })
                document.cookie = `emailId=${this.state.userEmail}; path=/`;
                document.cookie = `userId=${this.state.userId}; path=/`;
                document.cookie = `auth_token=${resp.data?.auth_token}; path=/`;
                document.cookie = `ssoToken=${resp.data?.auth_token}; path=/`;
                document.cookie = `enterpriseId=TaD1VC1Ko; path=/`;

                posthog.capture('Login', { $set: { email: this.state.userEmail, userId : resp.data.user_id, newUser: 'true'} });
                
                this.context.loggedIn({
                    loggedIn: true,
                    user: {
                        emailId: this.state.userEmail,
                        userId: resp.data?.user_id
                    },
                    token: resp.data?.auth_token,
                    apiKey: process.env.REACT_APP_API_KEY
                })
                // window.location.reload()
                this.props.insertUsersImage(resp.data?.auth_token)
            }
        })
    }

    handleGoogleLogin = (userEmail,userName) => {
        // e.preventDefault()
        const fd = new FormData()
        fd.append('email_id', userEmail)
        fd.append('api_key', process.env.REACT_APP_API_KEY)
        fd.append('strategy', 'GOOGLE')
        Axios({
            method: "POST",
            url: process.env.REACT_APP_BASEURL + "/v2/user/login",
            data: fd
        }).then(this.handleLoginResponse)
    }

    handleSignIn = () => {
        this.setState({
            stepOneLogin: !this.state.stepOneLogin,
            stepOne: true,
            otpSent: false,
            islogin: true
        })
    }

    handleLoginPass = () => {
        this.setState({
            stepOne: false,
            loginCheck: true,
            isPassword: true
        })
    }

    handleLoginOtp = () => {
        this.setState({
            stepOne: false,
            isPassword: false
        })
    }

    render(){
        let {loginCheck,stepOne, category,otpSent,stepOneLogin} = this.state
        return (
            <div className="signup-area-main">
    
                {stepOne ? 
                    <div className="signup-area">
                        {stepOneLogin ? 
                            <div className="col-md-12 google-signup logo-img">
                                <img src="https://storage.googleapis.com/spyne-website/static/website-themes/spyne/images/spyne-black-logo.png"/> 
                                <p>Your Image is Ready. Please Sign Up Continue...</p>
                                {/* <h6><img src="https://storage.googleapis.com/spyne-website/self-serve/Automobile/Google%20Logo.png"/> <span>Continue with Google </span></h6> */}
                                <div className="google-btn">
                                    <GoogleLogin
                                        clientId="887824920844-6n7pic33ra30hf0mjlrc8f1m6qt6hs9r.apps.googleusercontent.com"
                                        buttonText="Login"
                                        onSuccess={this.responseGoogle}
                                        onFailure={this.responseGoogle}
                                        cookiePolicy={'single_host_origin'}
                                        // isSignedIn={true}
                                        buttonText="Login with Google"
                                    />
                                </div>
                                {this.state.validEmail ? 
                                    <h4>Invalid Email</h4>
                                    :
                                    null
                                }
                                
                                
                                <h5><span>OR</span></h5>
                                <div className="row pass-otp-card">
                                    <div className="col-md-6 col-6 pass-sm">
                                        <button className="using-pass" onClick={this.handleLoginPass}><img src="https://storage.googleapis.com/spyne-website/self-serve/pass.png"/>  <p>Login Using Password</p></button>
                                    </div> 
                                    <div className="col-md-6 col-6 pass-sm">
                                        <button className="using-otp" onClick={this.handleLoginOtp}><img src="https://storage.googleapis.com/spyne-website/self-serve/otp-1.png"/> <p>Login Using OTP </p></button>
                                    </div>
                                </div>
                                <small>New User ? <a onClick={this.handleSignIn}>Sign Up</a></small>
                            </div>
                            :
                            <div className="col-md-12 google-signup">
                                <h3>Create Account.</h3>
                                <p>Your Image is Ready. Please Sign Up Continue...</p>
                                {/* <h6><img src="https://storage.googleapis.com/spyne-website/self-serve/Automobile/Google%20Logo.png"/> <span>Continue with Google </span></h6> */}
                                <div className="google-btn">
                                    <GoogleLogin
                                        clientId="887824920844-6n7pic33ra30hf0mjlrc8f1m6qt6hs9r.apps.googleusercontent.com"
                                        buttonText="Login"
                                        onSuccess={this.responseGoogle}
                                        onFailure={this.responseGoogle}
                                        cookiePolicy={'single_host_origin'}
                                        // isSignedIn={true}
                                        buttonText="Continue with Google "
                                    />
                                </div>
                                {this.state.emailExists ? 
                                    <h4 >Email Id Already Exists. <a style={{textDecoration:"underline"}} className={styles['login-here']} onClick={this.handleLoginModal}>Login here</a></h4>
                                    :
                                    null
                                }
                                <h5><span>OR</span></h5>
                                <div className="row pass-otp-card">
                                    <div className="col-md-6 col-6 pass-sm">
                                        <button className="using-pass" onClick={this.handlePassword}><img src="https://storage.googleapis.com/spyne-website/self-serve/pass.png"/>
                                        <p>Signup Using Password</p></button>
                                    </div>
                                
                                    <div className="col-md-6 col-6 pass-sm">
                                        <button className="using-otp" onClick={this.handleOtp}><img src="https://storage.googleapis.com/spyne-website/self-serve/otp-1.png"/> 
                                        <p>Signup Using OTP </p></button>
                                    </div>
                                </div>
                               
                                <small>Already a user ? <a onClick={this.handleSignIn}>Login</a></small>
                                <h2>Sign Up to Claim <b>10 Free Credits.</b><span className={[styles['sku-tooltip'],''].join(' ')}><img src="https://storage.googleapis.com/spyne-website/self-serve/info.png"/></span>
                                    <div className={[styles['tooltiptext'],''].join(' ')}> 1/5 credit will be charged via Apps and API.
                                    Full Images up to 25 megapixel (eg: 6250 x 4000 ) will be charged as 1 credit</div>
                                </h2>
                            </div>
                        }
                        
                        
                    </div>
                    
                    :
                    loginCheck ? 
                    <div className="col-md-12 google-signup signup-form">
                        <form onSubmit={this.state.isPassword ? this.handleLogin : !this.state.otpSent? this.handleOtpRequest : this.handleLogin} >
                            <img class="img-fluid LoginPage_logo__yYiBp" src="https://eventila.spyne.ai/logos/spyne-logo/bg-less-title.png"/>
                            <p>Spyne.ai Login</p>
                            <input type="email" placeholder="Enter Email" className="form-control" onChange={this.handleChange}/>
                            
                                {this.state.isPassword ?
                                <input className="form-control " type="password" placeholder="Enter your Password" onChange={this.handleChangePassword} ref={this.passwordRef}></input>
                                :
                                <input className="form-control " type="text" placeholder="Enter your OTP" onChange={this.handleChangeOTP} disabled={!otpSent ? true : false} ref={this.passwordRef}></input>
                                }
                                {this.state.otpMessage ? 
                                    <h6>One Time Password has been sent to your Email</h6>
                                    : null
                                }
                                
                                {!this.state.otpValid ? 
                                <h4>Please Enter Valid OTP</h4>
                                :
                                null
                                }
                                {this.state.validEmail ? 
                                <h4>Invalid Credentials</h4>
                                :
                                null
                                }
                                {this.state.isPassword ? 
                                    <button className="submit-btns" type="submit">Login</button>
                                    :
                                   <button className="submit-btns" type="submit">{!this.state.otpSent ? 'Request OTP' : 'Verify OTP'}</button>
                                       
                                    // {/* <button className="using-pass" type="submit">{!this.state.otpSent ? 'Request OTP' : 'Verify OTP'}</button> */}
                            }
                            {/* <input type="password" placeholder="Enter Password" className="form-control"/> */}
                            {/* <button className="using-pass">SignIn</button>   */}
                            <small>New user ? <a onClick={this.handleSignIn}>Sign Up</a></small>
                        </form>
                    </div>
                    :
                    <div className="col-md-12 google-signup signup-form">
                        <form onSubmit={this.state.isPassword? this.handleSignUpPassword : !this.state.otpSent ? this.sendOTP : this.verifyOtp}>
                            <img class="img-fluid LoginPage_logo__yYiBp" src="https://eventila.spyne.ai/logos/spyne-logo/bg-less-title.png"/>
                            <p>Spyne.ai Sign Up</p>
                            <input type="email" placeholder="Enter Email" className="form-control" onChange={this.handleChange}/>
                            
                            {this.state.isPassword ?
                            (   
                                <input className="form-control " required={true} type="password" placeholder="Enter your Password" onChange={this.handleChangePassword} ref={this.passwordRef}></input>
                            )
                            
                            :
                            <input className="form-control " required={true} type="text" placeholder="Enter your OTP" onChange={this.handleChangeOTP} disabled={!otpSent ? true : false} ref={this.passwordRef} ></input>
                            }
                            {this.state.otpMessage ? 
                                <h6>One Time Password has been sent to your Email</h6>
                                : null
                            }
                            {!this.state.otpValid ? 
                            <h4>Please Enter Valid OTP</h4>
                            :
                            null 
                            }
                            {this.state.emailExists ? 
                            <h4 >Email Id Already Exists. <a style={{textDecoration:"underline"}} className={styles['login-here']} onClick={this.handleLoginModal}>Login here</a></h4>
                            :
                            null
                            }
                            
                            {this.state.isPassword ? 
                                
                                <button className="submit-btns" type="submit" disabled={this.state.isSigningIn?true:false}>Sign up</button>  
                                :
                                <button className="submit-btns" type="submit">{!this.state.otpSent ? 'Request OTP' : 'Verify OTP'}</button>
                                        
                                // <button className="" type="submit">{!this.state.otpSent ? 'Request OTP' : 'Verify OTP'}</button>
                            }
                            {/* <input type="password" placeholder="Enter Password" className="form-control"/>
                            <button className="using-pass">Signup</button>   */}
                            <small style={{marginTop:"25px"}}>Already a user ? <a onClick={this.handleSignIn}>Login</a></small>
                        </form>
                    </div>
    
                }
                
    
                
                
            </div>
        )
    }
    
}

export default LoginScreen
